import { isIOS, isMobile, isDartWebView } from './util/util';
var globalScope = window;
export var sendToNative = function (name, encodeParam, prefix) {
    if (prefix === void 0) { prefix = ''; }
    if (isDartWebView()) {
        var apiName = prefix + "_" + name;
        if (prefix && globalScope[apiName]) {
            globalScope[apiName].postMessage(encodeParam);
            return true;
        }
        return false;
    }
    else if (isIOS()) {
        var IOSApiName = prefix ? prefix + "_" + name : name;
        var messageHandler = globalScope.webkit && globalScope.webkit.messageHandlers;
        if (messageHandler) {
            if (messageHandler[IOSApiName]) {
                messageHandler[IOSApiName].postMessage(encodeParam);
                return true;
            }
        }
        else {
            if (isMobile()) {
                var doc = window.document;
                var body = doc.body;
                var iframe = doc.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = "async:" + IOSApiName + ":" + encodeParam;
                body.appendChild(iframe);
                body.removeChild(iframe);
                return true;
            }
        }
    }
    else {
        var handlerName = (prefix ? prefix[0].toUpperCase() + prefix.substring(1) : '') + 'WebView';
        var messageHandler = globalScope[handlerName];
        if (messageHandler && messageHandler[name]) {
            messageHandler[name](encodeParam);
            return true;
        }
    }
    return false;
};
